import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMovement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 11,
	viewBox: "0 0 32 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.80005 5.5H28.4501",
			stroke: "currentColor",
			strokeWidth: 3.42,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75005 2.34961L2.55005 5.49961L6.75005 8.64961V2.34961Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 3.42,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.0128 5.50031C27.0128 4.28229 28.0003 3.29475 29.2183 3.29475C30.4364 3.29475 31.4239 4.28229 31.4239 5.50031C31.4239 6.71834 30.4364 7.70587 29.2183 7.70587C28.0003 7.70587 27.0128 6.71834 27.0128 5.50031Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .152
		})
	]
});
export default SvgMovement;
